import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const SummaryFormWrapper = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '3 / 11'
  }
});

export const DialogContentStyle = ({ theme }) => ({
  paddingTop: '40px !important',
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: '100px',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    paddingTop: '60px !important'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const Wrapper = styled(Stack)(SummaryFormWrapper);
